export default __webpack_public_path__ + "assets/mondev.5fcc5118.webp";